export function dataInRequest(params = {}) {
  return {
    type: '@estoquePostoMonitor/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@estoquePostoMonitor/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@estoquePostoMonitor/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@estoquePostoMonitor/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@estoquePostoMonitor/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@estoquePostoMonitor/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@estoquePostoMonitor/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@estoquePostoMonitor/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@estoquePostoMonitor/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@estoquePostoMonitor/RECORD_FILTERING',
    payload: { params },
  };
}
